export const GOD = 'GOD'